export const parseBytesTo = (bytes) => {
    const POWER_FOR_GB = 3;
    const POWER_FOR_TB = 4;

    const KB_MULTIPLE = 1024;
    const MB_MULTIPLE = KB_MULTIPLE ** 2;
    const GB_MULTIPLE = KB_MULTIPLE ** POWER_FOR_GB;
    const TB_MULTIPLE = KB_MULTIPLE ** POWER_FOR_TB;

    const calc = (multiple) => +(bytes / multiple).toFixed(2);

    const KB = calc(KB_MULTIPLE);
    const MB = calc(MB_MULTIPLE);
    const GB = calc(GB_MULTIPLE);
    const TB = calc(TB_MULTIPLE);

    return {
        KB,
        MB,
        GB,
        TB,
        auto: () => {
            if (TB >= 1) {
                return `${TB} TB`;
            }
            if (GB >= 1) {
                return `${GB} GB`;
            }
            if (MB >= 1) {
                return `${MB} MB`;
            }
            if (KB >= 1) {
                return `${KB} KB`;
            }
            return `${bytes} B`;
        }
    };
};